export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0xf0CFe22d23699ff1B2CFe6B8f706A6DB63911262",
  eulerSwapV1Implementation: "0x3Ce63C16CB719a0c755DA25cd5dD35170A00424f",
  eulerSwapV1Periphery: "0x18e5F5C1ff5e905b32CE860576031AE90E1d1336",
} as const
